export enum WarehouseStatusEnum {
  ACTIVE = 'active',
  INACTIVE = 'draft',
  DELETED = 'deleted'
}
